import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useFleetApi from './useFleetApi';
import '../OpsShared.css';
import './FleetReports.css';

const EMPTY = {
  unit_code: '', type: 'truck', make: '', model: '', year: '',
  vin: '', plate: '', status: 'active', odometer: '', in_service_date: '',
  fuel_type: 'gas'
};

export default function VehicleForm() {
  const { id } = useParams();
  const editing = !!id;
  const { getVehicle, createVehicle, updateVehicle } = useFleetApi();
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!editing) return;
    (async () => {
      const data = await getVehicle(id);
      setForm({
        unit_code: data.unit_code || '',
        type: data.type || 'truck',
        make: data.make || '', model: data.model || '',
        year: data.year || '', vin: data.vin || '', plate: data.plate || '',
        status: data.status || 'active',
        odometer: data.odometer ?? '',
        in_service_date: data.in_service_date || '',
        fuel_type: data.fuel_type || 'gas',
      });
    })();
  }, [editing, id, getVehicle]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = {
        ...form,
        year: form.year ? Number(form.year) : null,
        odometer: form.odometer === '' ? null : Number(form.odometer),
      };
      if (editing) await updateVehicle(id, payload);
      else await createVehicle(payload);
      navigate('/operations/fleet');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="ops-page">
      <header className="ops-head">
        <div>
          <h1>{editing ? 'Edit vehicle' : 'New vehicle'}</h1>
          <div className="ops-muted">{editing ? 'Update this unit’s details.' : 'Add a unit to the fleet.'}</div>
        </div>
      </header>

      <section className="ops-section">
        <form className="ops-form" onSubmit={onSubmit}>
          <div className="ops-field"><label>Unit code</label><input name="unit_code" value={form.unit_code} onChange={onChange}/></div>
          <div className="ops-field"><label>Type</label>
            <select name="type" value={form.type} onChange={onChange}>
              <option value="truck">Truck</option><option value="van">Van</option>
              <option value="car">Car</option><option value="sprayer">Sprayer</option>
              <option value="trailer">Trailer</option><option value="other">Other</option>
            </select>
          </div>
          <div className="ops-field"><label>Make</label><input name="make" value={form.make} onChange={onChange}/></div>
          <div className="ops-field"><label>Model</label><input name="model" value={form.model} onChange={onChange}/></div>
          <div className="ops-field"><label>Year</label><input name="year" type="number" value={form.year} onChange={onChange}/></div>
          <div className="ops-field"><label>VIN</label><input name="vin" value={form.vin} onChange={onChange}/></div>
          <div className="ops-field"><label>Plate</label><input name="plate" value={form.plate} onChange={onChange}/></div>
          <div className="ops-field"><label>Status</label>
            <select name="status" value={form.status} onChange={onChange}>
              <option value="active">Active</option>
              <option value="in_service">In service</option>
              <option value="retired">Retired</option>
            </select>
          </div>
          <div className="ops-field"><label>Odometer (mi)</label><input name="odometer" type="number" value={form.odometer} onChange={onChange}/></div>
          <div className="ops-field"><label>In-service date</label><input name="in_service_date" type="date" value={form.in_service_date} onChange={onChange}/></div>
          <div className="ops-field"><label>Fuel type</label>
            <select name="fuel_type" value={form.fuel_type} onChange={onChange}>
              <option value="gas">Gas</option><option value="diesel">Diesel</option>
              <option value="hybrid">Hybrid</option><option value="ev">EV</option>
            </select>
          </div>

          <div className="ops-form__actions">
            <button type="button" className="ops-btn secondary" onClick={() => navigate(-1)}>Cancel</button>
            <button type="submit" className="ops-btn" disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
          </div>
        </form>
      </section>
    </div>
  );
}